/**
 * Remembered destination for ⚡ Import nhanh. Set once (pick a folder the
 * first time), reused for every subsequent quick import until changed.
 * Per browser (localStorage) — each device remembers its own folder.
 */

import type { DriveFolder } from "../hooks/useGoogleDrive.js";

const QUICK_FOLDER_KEY = "kra_quick_import_folder";

/** Read the saved quick-import destination, or null if not set yet. */
export function readQuickFolder(): DriveFolder | null {
  try {
    const raw = localStorage.getItem(QUICK_FOLDER_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<DriveFolder>;
    return p?.id ? { id: p.id, name: p.name ?? "Thư mục import nhanh" } : null;
  } catch {
    return null;
  }
}

/** Persist the quick-import destination so future quick imports skip the picker. */
export function writeQuickFolder(f: DriveFolder): void {
  try {
    localStorage.setItem(QUICK_FOLDER_KEY, JSON.stringify({ id: f.id, name: f.name }));
  } catch {
    /* storage disabled — quick import just falls back to the picker next time */
  }
}

/** Forget the destination — the next ⚡ asks for a folder again. */
export function clearQuickFolder(): void {
  try {
    localStorage.removeItem(QUICK_FOLDER_KEY);
  } catch {
    /* nothing to clear */
  }
}
